import React from 'react';
import {
	CommonActivityImage,
	CommonActivityTitle,
	CommonActivityDetail,
} from '../../../../data/statusDefinitions';
import { currentIsoDate, dayJS, formatDate } from '../../../../utils/date';
import { Link } from 'react-router-dom';

function ActivityElement(props) {
	function replaceMetaData(text) {
		if (text === undefined || text.length === 0) return '';

		if (text.includes('{{date}}'))
			if (props?.appointment !== undefined) {
				text = text.replace(
					'{{date}}',
					props?.appointment?.appointmentDate !== undefined
						? `${formatDate(
								props?.appointment?.appointmentDate,
								'DD.MM.YYYY'
						  )} à
								${formatDate(props?.appointment?.appointmentDate, 'HH[h]mm')}`
						: 'N/A'
				);
			}

		if (text.includes('{{client}}'))
			text = text.replace(
				'{{client}}',
				`${props?.data?.client?.firstName} ${props?.data?.client?.lastName}`
			);

		if (text.includes('{{expert}}'))
			text = text.replace(
				'{{expert}}',
				`${props?.data?.expert?.firstName} ${props?.data?.expert?.lastName}`
			);

		if (text.includes('{{commissionDate}}'))
			text = text.replace(
				'{{commissionDate}}',
				dayJS(props?.data?.expertCommission?.nextAt).format('DD/MM/YYYY')
			);

		return text;
	}

	return (
		<Link to={props.goTo} className="activity-elements">
			<img
				src={CommonActivityImage[props.role][props.type]}
				alt="wallet icon"
				className="activity-icons"
			/>
			<div className="activity-container-main">
				<div className="activity-container-detail">
					<div className="activity-title">
						{replaceMetaData(CommonActivityTitle[props.role][props.type])}
					</div>
					<div className="activity-detail">
						{replaceMetaData(CommonActivityDetail[props.role][props.type])}
					</div>
				</div>
				<div className="activity-container-infos">
					<div className="activity-date">
						{formatDate(currentIsoDate, 'DD.MM.YYYY')}
					</div>
					{props.type === 13 && <div className="activity-hour"></div>}
				</div>
			</div>
			<div className="separator"></div>
		</Link>
	);
}

export default ActivityElement;
